import { apiFetch } from "@/lib/api/client";

export type AlertCategory = "pt" | "class" | "membership" | "approval" | "credit_sale" | "general";

export interface StaffAlert {
  id: string;
  category: AlertCategory;
  event_type: string;
  title: string;
  body: string;
  actor_name: string;
  link: string;
  action_id: string;
  is_read: boolean;
  created_at: string;
}

export interface StaffAlertsResponse {
  unread_count: number;
  results: StaffAlert[];
}

export function listStaffAlerts(): Promise<StaffAlertsResponse> {
  return apiFetch<StaffAlertsResponse>("/notifications/alerts/");
}

export function markAlertsRead(ids?: string[]): Promise<{ marked_read: number }> {
  return apiFetch<{ marked_read: number }>("/notifications/alerts/mark-read/", {
    method: "POST",
    body: JSON.stringify(ids ? { ids } : {}),
  });
}

export function approvePtBooking(bookingId: string): Promise<{ id: string; status: string }> {
  return apiFetch(`/staff/pt/bookings/${bookingId}/approve/`, { method: "POST" });
}

export function rejectPtBooking(bookingId: string): Promise<{ id: string; status: string }> {
  return apiFetch(`/staff/pt/bookings/${bookingId}/reject/`, { method: "POST" });
}

export function approveClassBooking(bookingId: string): Promise<{ id: string; status: string }> {
  return apiFetch(`/classes/bookings/${bookingId}/approve/`, { method: "POST" });
}

export function rejectClassBooking(bookingId: string, reason = ""): Promise<{ id: string; status: string }> {
  return apiFetch(`/classes/bookings/${bookingId}/reject/`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}
